export const speakerSection = [
    {
        name: '',
        about: '',
        src: '',
    },
    {
        src: 'images/Hero_section/speakers/aaron_levie.png',
        name: 'Aaron Levie',
        about: 'Box',
    },
    {
        src: 'images/Hero_section/speakers/steve_jurvetson.png',
        name: 'Steve Jurvetson',
        about: 'Venture Capitalist',
    },
    {
        name: 'Elon Musk',
        about: 'Tesla',
        src: 'images/Hero_section/speakers/elon_musk.png',
    },
    {
        name: 'Andrew Chen',
        about: 'a16z',
        src: 'images/Hero_section/speakers/andrew_chen.png',
    },
    {
        name: 'Borja Martel',
        about: 'Lemon Cash',
        src: 'images/Hero_section/speakers/borja_martel.png',
    },
    {
        name: 'Amanda Bradford',
        about: 'The League',
        src: 'images/Hero_section/speakers/amanda_bradford.png',
    },
    {
        name: 'Michelle Phan',
        about: 'EM Cosmetics',
        src: 'images/Hero_section/speakers/michelle_phan.png',
    },
    {
        name: 'John Zimmer',
        about: 'Lyft',
        src: 'images/Hero_section/speakers/john_zimmer.png',
    },
    {
        name: '',
        about: '',
        src: '',
    },
];
export const speakerSectionBlockchain = [
    {
        name: '',
        about: '',
        src: '',
    },
    {
        src: 'images/blockchain_page/speakers/adam_draper.png',
        name: 'Adam Draper',
        about: 'Boost VC',
    },
    {
        src: 'images/blockchain_page/speakers/bruno_faviero.jpg',
        name: 'Bruno Faviero',
        about: 'Magna',
    },
    {
        name: 'Jason Lee',
        about: 'Algorand',
        src: 'images/blockchain_page/speakers/jason_lee.jpg',
    },
    {
        name: 'Mike Arrington',
        about: 'Arrington Capital',
        src: 'images/blockchain_page/speakers/mike_arrington.png',
    },
    {
        name: 'Shiv Sakhuja',
        about: 'Magik Invest',
        src: 'images/blockchain_page/speakers/shiv_sakhuja.jpg',
    },
    {
        name: 'Marcelo Cavazzoli',
        about: 'Lemon Cash',
        src: 'images/blockchain_page/speakers/marcelo_cavazzoli.jpeg',
    },
    {
        name: 'Travis Wu',
        about: 'lumièreVR',
        src: 'images/blockchain_page/speakers/travis_wu.jpg',
    },
    {
        name: 'Emmie Chang',
        about: 'Hoo',
        src: 'images/blockchain_page/speakers/emmie_chang.jpg',
    },
    {
        name: 'Sunny Lu',
        about: 'VeChain',
        src: 'images/blockchain_page/speakers/sunny_lu.jpg',
    },
    {
        name: '',
        about: '',
        src: '',
    },
];
export const speakerSectionVcx = [
    {
        name: '',
        about: '',
        src: '',
    },
    {
        src: '/images/vcx_program/Speaker images/Tim Draper, Draper Associates.png',
        name: 'Tim Draper',
        about: 'Draper Associates',
    },
    {
        src: '/images/vcx_program/Speaker images/Steve Jurvetson.png',
        name: 'Steve Jurvetson',
        about: 'Venture Capitalist',
    },
    {
        src: '/images/vcx_program/Speaker images/Andy Tang, Draper Associates.png',
        name: 'Andy Tang',
        about: 'Draper Associates',
    },
    {
        src: '/images/vcx_program/Speaker images/Sid Mofya, Draper Venture Network.png',
        name: 'Sid Mofya',
        about: 'Draper Venture Network',
    },
    {
        src: '/images/vcx_program/Speaker images/Andrew Chen, a16z.png',
        name: 'Andrew Chen',
        about: 'a16z',
    },
    {
        name: '',
        about: '',
        src: '',
    },
];
export const sliderRightMbl = [
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Maria_Sofia_Castillo/Maria_Sofia_Castillo.png ',
        person_name: 'Maria Sofia Castillo',
        date: 'January 2020',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Maria_Sofia_Castillo/core_code.png',
        width: '100%',
        company_name: 'Core Code',
    },
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Jennifer_Wong/Jennifer_Wong.png',
        person_name: 'Jannifer Wong',
        date: 'January 2020',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Jennifer_Wong/phyta_zenica.png',
        width: '80%',
        company_name: 'Phyta Zenica',
    },
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Murad_Nathani/Murad_Nathani.png',
        person_name: 'Murad Nathani',
        date: 'January 2020',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Murad_Nathani/Sepio Solutions.png',
        width: '40%',
        company_name: 'Sepio',
    },
    {
        image: 'images/fundamental_programs/Fundamentals'+
        '_Alumni/Alessandra_Menezes_Morelle/Alessandra_Menezes_Morelle.png',
        person_name: 'Menezes _Morelle',
        date: 'January 2020',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Alessandra_Menezes_Morelle/thummi.svg',
        width: '100%',
        company_name: 'Thummi',
    },
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Jeff_Hu/Jeff_Hu.png',
        person_name: 'Jeff Hu',
        date: 'September 2021',
        company_logo: 'images/fundamental_programs/Fundamentals_Alumni/Jeff_Hu/turning curts.svg',
        width: '80%',
        company_name: 'Turing Certs',
    },
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Linjian_Xiang/Linjian_Xiang.png',
        person_name: 'Linjian Xiang',
        date: 'October 2020',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Linjian_Xiang/Robolution.png',
        width: '40%',
        company_name: 'Robolution ',
    },
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Maria_Mateo_Iborra/Maria_Mateo_Iborra.png',
        person_name: 'Maria Meteo Iborra',
        date: 'June 2021',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Maria_Mateo_Iborra/Ibisa Network.png',
        width: '60%',
        company_name: 'Ibisa',
    },
    {
        image: 'images/fundamental_programs/Fundamentals_Alumni/Amy_Chen/Amy_Chen.png',
        person_name: 'Amy Chen',
        date: 'June 2020',
        company_logo:
            'images/fundamental_programs/Fundamentals_Alumni/Amy_Chen/Vaultbase.png',
        width: '42%',
        company_name: 'Vaultbase ',
    },
];
export const sliderLeftMbl = [
    {
        image: 'images/Hero_training_companies_logos/loopd_03.svg ',
        person_name: 'Looped Inc',
        company_name: 'Brian Friedman',
    },
    {
        image: 'images/Hero_training_companies_logos/Benjamin Ries, Summer 2013, Roby.svg',
        person_name: 'Roby',
        company_name: 'Benjamin Ries',
    },
    {
        image: 'images/Hero_training_companies_logos/Amira Geneid, Fall 2014, Zahara.svg',
        person_name: 'Zahara',
        company_name: 'Amira Geneid',
    },
    {
        image: 'images/Hero_training_companies_logos/Akshay Chaturvedi, Spring 2015, Leverage_Logo.svg',
        person_name: 'Leverage',
        company_name: 'Akshay Chaturvedi',
    },
    {
        image: 'images/Hero_training_companies_logos/Adegoke (Goke) Olubusi, Summer 2014, Helium Health.svg',
        person_name: 'Helium Health',
        company_name: 'Adegoke Olubusi',
    },
    {
        image: 'images/Hero_training_companies_logos/Luciano Bueno, Spring 2015, GALY.svg',
        person_name: 'Galy',
        company_name: 'Luciano Bueno ',
    },
    {
        image: 'images/Hero_training_companies_logos/Matt Blanchard, Algorand 2021.svg',
        person_name: 'Cosmic Champs ',
        company_name: 'Matt Blanchard',
    },
    {
        image: 'images/Hero_training_companies_logos/Konstantin Maslennikov, Summer 2017, TakeBus.svg',
        person_name: 'Take Bus',
        company_name: 'Konstantin Maslennikov ',
    },
];
export const heroCurriculumMbl = [
    {

        img: '/images/Hero_section/Hero_Training_icons/Vision_and_Future.svg',
        img_width: '100%',
        title: 'Vision and Future',
        text: 'Develop a clear vision for your business venture via processes '+
        'such as futurology, predictive analysis and idea generation',
        Program_heading1: [
            {point: 'Futurology'},
            {point: 'Predictive Analysis'},
        ],
        Program_heading2: [
            {point: 'Idea Generation'},
            {point: 'Young Founder Series'},
        ],

    },
    {
        img: '/images/Hero_section/Hero_Training_icons/Money_and_Resources.svg',
        img_width: '100%',
        title: 'Money and Resources',
        text: 'Discover how to access and leverage a variety of financial resources to launch and '+
        'sustain your business concept. Examples include venture capital, fundraising strategies and crypto.',
        Program_heading1: [
            {point: 'Bitcoin'},
            {point: 'Banking & Finance'},
        ],
        Program_heading2: [
            {point: 'Venture Capital'},
            {point: 'Fundraising Strategies'},
        ],
    },
    {
        img: '/images/Hero_section/Hero_Training_icons/Strenght_and_Speed.svg',
        img_width: '100%',
        title: 'Strenght and Speed',
        text: 'Learn how to use prototyping to develop your business'+
        ' idea, run a lean operation and scale your enterprise when the time comes',
        Program_heading1: [
            {point: 'Prototyping'},
            {point: 'Scaling Your Business'},
        ],
        Program_heading2: [
            {point: 'Founders vs CEOs'},
            {point: 'Learn Startup Methadology'},
        ],
    },
    {
        img: '/images/Hero_section/Hero_Training_icons/Legal_and_Justice.svg',
        img_width: '100%',
        title: 'Legal and Justice',
        text: 'Determine the best company structure for your organization from a legal perspective (corporation, LLC, '+
        'etc.) and receive a law primer geared towards startup ventures.',
        Program_heading1: [
            {point: 'Term Sheets'},
            {point: 'Company Structure'},
        ],
        Program_heading2: [
            {point: 'Incorporation'},
            {point: 'Law Primer for Startups'},
        ],
    },
    {
        img: '/images/Hero_section/Hero_Training_icons/Creativity.svg',
        img_width: '20vw',
        title: 'Creativity',
        text: 'Learn how to become a zealous advocate for your startup and promote your business'+
        ' effectively through media training, branding and storytelling, sales and digital marketing and networking.',
        Program_heading1: [
            {point: 'Pretotyping'},
            {point: 'Disruptive Innovation'},
        ],
        Program_heading2: [
            {point: 'Design Thinking'},
            {point: 'Designing Products and Teams'},
        ],
    },
    {
        img: '/images/Hero_section/Hero_Training_icons/Special_Power.svg',
        img_width: '20vw',
        title: 'Special Power',
        text: 'Unleash your creativity and validate your product ideas with tools and techniques '+
        'like prototyping, disruptive innovation and design thinking.',
        Program_heading1: [
            {point: 'Coding'},
            {point: 'Lie Detection'},
        ],
        Program_heading2: [
            {point: 'Negotiations'},
            {point: 'Perfecting Your Pitching'},
        ],
    },
    {
        img: '/images/Hero_section/Hero_Training_icons/Evangelism.svg',
        img_width: '100%',
        title: 'Evangelism',
        text: `Numerous obstacles and a few potholes line the road to success. Develop'+
        ' the warrior mindset you need to keep going when things '+
        'get tough. You'll also learn how to take lessons from failure and use them to your advantage.`,
        Program_heading1: [
            {point: 'Media Training'},
            {point: 'Power Up your Network'},
        ],
        Program_heading2: [
            {point: 'Branding and Storytelling'},
            {point: 'Sales and Digital Marketing'},
        ],
    },
    {
        img: '/images/Hero_section/Hero_Training_icons/Survival.svg',
        img_width: '100%',
        title: 'Survival',
        text: `You'll need a few special powers to achieve your entrepreneurial goals. Learn to master `+
        `the fine arts of negotiating, idea pitching and lie detection to give you a competitive edge.`,
        Program_heading1: [
            {point: 'Warrior Mindset'},
            {point: 'Resource Valuation'},
        ],
        Program_heading2: [
            {point: 'Lessons in Failure'},
            {point: 'Critical Success Factor'},
        ],
    },
];
export const heroSocailLogo = [
    {
        img1: '/images/fundamental_programs/DUV_Logos/Blowhorn.png',
        img1_width: '17vw',
        img1_height: '6vw',
        img2: '/images/fundamental_programs/DUV_Logos/Ibisa.png',
        img2_width: '17vw',
        img2_height: '6vw',
        img3: '/images/fundamental_programs/DUV_Logos/Strive.png',
        img3_width: '17vw',
        img3_height: '6vw',
    },
    {
        img1: '/images/fundamental_programs/DUV_Logos/ELSI.png',
        img1_width: '15vw',
        img1_height: '8vw',
        img2: '/images/fundamental_programs/DUV_Logos/Boon.png',
        img2_width: '16vw',
        img2_height: '8vw',
        img3: '/images/fundamental_programs/DUV_Logos/Quilo.png',
        img3_width: '14vw',
        img3_height: '8vw',
    },
    {
        img1: '/images/fundamental_programs/DUV_Logos/Bayseddo.png',
        img1_width: '15vw',
        img1_height: '10vw',
        img2: '/images/fundamental_programs/DUV_Logos/Busy.png',
        img2_width: '15vw',
        img2_height: '',
        img3: '/images/fundamental_programs/DUV_Logos/Ecoin.png',
        img3_width: '15vw',
        img3_height: '',
    },
];
export const fundamentalCurriculumMbl = [
    {

        img: '/images/fundamental_programs/FOE_Curicullum_Icons/Group 15499.svg',
        title: 'Develope Your Business',
        text: 'Learn how to develop your business from Silicon Valley Founders and Experts',

    },
    {
        img: '/images/fundamental_programs/FOE_Curicullum_Icons/Group 15500.svg',
        title: 'Online activities',
        text: 'The Program is delivered through online lectures by Silicon Valley '+
        'Experts and Founders, and through group live activities around challenges',
    },
    {
        img: '/images/fundamental_programs/FOE_Curicullum_Icons/Group 15501.svg',
        title: '1:1 Mentoring',
        text: '5 Sessions of 1-1 Mentoring with Worldwide industry experts, mentors and investors '+
        'committed to supporting you on your entrepreneurial journey',
    },
    {
        img: '/images/fundamental_programs/FOE_Curicullum_Icons/Group 15502.svg',
        title: '$100,000 funding',
        text: 'Draper University has a fund dedicated to investing up'+
        ' to $100,000 in chosen alumni companies of this program',
    },
];
export const socailLogoGlobalMbl = [
    {
        img1: '/images/global_section/partner_logogs/UNDP_logo.svg',
        img1_width: '5vw',
        img1_height: '11vw',
        img2: '/images/global_section/partner_logogs/USAID.svg',
        img2_width: '12vw',
        img2_height: '6vw',
        img3: '/images/global_section/partner_logogs/Mitsubishi_Motors.png',
        img3_width: '8vw',
        img3_height: '11vw',
        img4: '/images/global_section/partner_logogs/monshaat.svg',
        img4_width: '10vw',
        img4_height: '9vw',
    },
    {
        img1: '/images/global_section/partner_logogs/ING.svg',
        img1_width: '12vw',
        img1_height: '9vw',
        img2: '/images/global_section/partner_logogs/Orange.svg',
        img2_width: '8vw',
        img2_height: '10vw',
        img3: '/images/global_section/partner_logogs/NIPA.svg',
        img3_width: '16vw',
        img3_height: '10vw',
        img4: '/images/global_section/partner_logogs/Turkish_Airlines.svg',
        img4_width: '11vw',
        img4_height: '10vw',
    },
    {
        img1: '/images/global_section/partner_logogs/SIDF.svg',
        img1_width: '10vw',
        img1_height: '9vw',
        img2: '/images/global_section/partner_logogs/KBW_Ventures.svg',
        img2_width: '14vw',
        img2_height: '10vw',
        img3: '/images/global_section/partner_logogs/MISK.svg',
        img3_width: '8vw',
        img3_height: '12vw',
        img4: '/images/global_section/partner_logogs/Sonatel.svg',
        img4_width: '12vw',
        img4_height: '11vw',
    },
    {
        img1: '/images/global_section/partner_logogs/KIC.svg',
        img1_width: '12vw',
        img1_height: '10vw',
        img2: '/images/global_section/partner_logogs/KISED.svg',
        img2_width: '11vw',
        img2_height: '12vw',
        img3: '/images/global_section/partner_logogs/dexis.svg',
        img3_width: '10vw',
        img3_height: '9vw',
        img4: '/images/global_section/partner_logogs/Growth_Circuit.svg',
        img4_width: '15vw',
        img4_height: '8vw',
    },
];
